export const NOTE_CHAR_LIMIT = 1000;
export const NOTE_CHAR_LIMIT_PIN = 500;
